import { render, staticRenderFns } from "./BillingCodesTable.vue?vue&type=template&id=10947a6d"
import script from "./BillingCodesTable.vue?vue&type=script&lang=js"
export * from "./BillingCodesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports